module.exports = __webpack_public_path__ + "static/media/4.15_preview.524146b0.png";